import { Injectable } from '@angular/core';
import { IBusinessAccountsConfig } from '@modules/business-accounts/utils/interfaces/business-accounts-wc.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigContextService {
  private readonly _config = new BehaviorSubject<IBusinessAccountsConfig | null>(null);

  get configValue() {
    return this._config.value;
  }

  get config$() {
    return this._config.asObservable();
  }

  set config(config: IBusinessAccountsConfig) {
    this._config.next(config);
  }
}
